module.exports = {
  "acq-0164": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "acq-0170": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "acq-0173": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a",
        "variant_b",
        "variant_c"
      ]
    }
  },
  "acq-0175": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a",
        "variant_b"
      ]
    }
  },
  "acq-0177": {
    "identifierType": "OTHER",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  }
};